import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { Navigate } from 'react-router-dom';
import type { RootState } from '../../store';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAdminAuthenticated } = useAppSelector((state: RootState) => state.adminAuth);

  // For admin routes, we'll let the component handle the authentication dialog
  // This allows for a better UX where users can see the admin interface and authenticate in place
  return <>{children}</>;
};

export default AdminProtectedRoute; 